<script setup lang="ts">
  import { FilterItemValueDto } from '@/VueComponents/Filter/Dtos/filterItemValueDto';

  defineProps<{
    filterItemValues: FilterItemValueDto[],
    name: string,
    isExpanded: boolean
  }>();
</script>

<template>
  <Transition>
    <ul
      v-show="isExpanded"
      :id="'filter-collapse-'+name"
      class="filter-panel__values--scrollable filter-panel__list--no-bullet filter-panel__values--indented"
      :aria-expanded="String(isExpanded)"
    >
      <li
        v-for="filter in filterItemValues"
        :key="filter.value"
      >
        <label>
          <input
            v-model="filter.isChecked"
            :data-test="filter.titleKey ? filter.titleKey: filter.title"
            type="checkbox"
            class="item-checkbox me-1"
            @change="filter.onCheckBoxInputChanged"
          >

          <i
            v-if="filter.type==='Persona'"
            class="fa-solid fa-user filter-panel__value-icon ms-1"
            :title="$localize('User')"
          />
          <i
            v-if="filter.type==='Group'"
            class="fa-solid fa-users filter-panel__value-icon ms-1"
            :title="$localize('Group')"
          />
          <span
            v-if="filter.title"
            class="filter-panel__value--text text-wrap-break-word ms-1"
          >
            {{ filter.title }}
          </span>
          <span
            v-if="filter.titleKey"
            class="filter-panel__value--text text-wrap-break-word ms-1"
          >
            {{ $localize(filter.titleKey) }}
          </span>
          <span class="filter-panel__value--text text-wrap-break-word ms-1">
            {{ filter.formattedCounter }}
          </span>
        </label>
      </li>
    </ul>
  </Transition>
</template>
<style>
    .v-enter-active,
    .v-leave-active {
        transition: opacity 0.5s ease;
    }

    .v-enter-from,
    .v-leave-to {
        opacity: 0;
    }
</style>